import CloseIcon from '@mui/icons-material/Close';
import { Button,DialogActions,DialogContent,DialogTitle,Stack,TextField,Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AttToken from "../../../helpers/attToken";
import Checklists from "../../../service/Checklists";
import queryClient from "../../../service/query";

type props = {
  open: boolean;
  handleCloseModal: Function;
  id: string;
  nome: string;
};

const formularioService = new Checklists();

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DeletaFormulaio({ open, handleCloseModal, id, nome }: props) {
  const { t } = useTranslation('translation');
  const [nomeInput, setNomeInput] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationKey: ['DELETE_CHECKLIST'],
    mutationFn: async () => {
      try {
        const promise = toast.promise(async () => {
          const token = await AttToken();
          if (!token) throw new Error("Token not found");
          if (token) {
            const response = await formularioService.deleteForm({ ...token, form: id });
            return response;
          }
        }, {
          pending: t('checklists.deleteFormModal.pending', { nome }),
          success: t('checklists.deleteFormModal.success', { nome }),
          error: t('checklists.deleteFormModal.error', { nome }),
        }, { toastId: 'deletando_modelo' });
        return promise;
      } catch (error) {
        throw new Error(`Erro ao deletar modelo de formulário: ${error}`);
      }
    },
    onSuccess: (_data) => {
      queryClient.refetchQueries({ queryKey: ['GET_INDEXES'] });
      handleCloseModal();
    },
  });

  return (
    <BootstrapDialog
      onClose={() => handleCloseModal()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('checklists.deleteFormModal.title')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleCloseModal()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='column' spacing={2} alignItems='baseline' justifyContent='flex-start' padding={2}>
          <Typography textAlign='left' fontWeight={600}>{t('checklists.deleteFormModal.confirmDeleteModel', { nome })}</Typography>
          <TextField
            required
            onChange={(event) => setNomeInput(event.target.value)}
            value={nomeInput}
            label={t('checklists.deleteFormModal.confirmTypeModelName')}
            variant="outlined"
            fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => mutate()} disabled={(nome !== nomeInput) || isPending}>
          {t('yes')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
